module.exports = __webpack_public_path__ + "static/brands3x-7bd04680551e089c1775565c4d5845e9.png";